import {
    createVNode as _$cv,
    className as _$cn,
    createElementVNode as _$ce,
} from 'intact';
import {isInvalid, noop} from 'intact-shared';
import {getRestProps, isEmptyString} from '../utils';
import {makeStyles} from './styles';

var _$tmp0 = {
    'aria-hidden': 'true'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    const {className} = this.get();
    const {k} = this.config;
    const {
        rootRef,
        contentRef,
    } = this.contentModel;
    const {
        shouldShowLoadingShell,
        shouldShowEmpty,
        shouldShowTypingSuffix,
    } = this.display;
    const renderedNodes = this.display.getRenderedNodes();
    const showLoadingShell = shouldShowLoadingShell();
    const showEmpty = shouldShowEmpty();
    const isEmptySlot = (value) => {
        if (isInvalid(value) || isEmptyString(value)) return true;
        if (Array.isArray(value)) return value.every(item => isEmptySlot(item));
        if (value && value.type === 1) return isEmptySlot(value.children);
    
        return false;
    };
    const loadingSlot = showLoadingShell && $blocks.loading ? $blocks.loading(noop) : undefined;
    const emptySlot = showEmpty && $blocks.empty ? $blocks.empty(noop) : undefined;
    const hasLoadingSlot = !isEmptySlot(loadingSlot);
    const hasEmptySlot = !isEmptySlot(emptySlot);
    
    const classNameObj = {
        [`${k}-xmarkdown`]: true,
        [className]: className,
        [makeStyles(k)]: true,
    };
    
    return _$cv('div', {
        'className': _$cn(classNameObj),
        ...getRestProps(this),
        'ref': rootRef
    }, (
        (showLoadingShell) ?
            (
                (hasLoadingSlot) ?
                    loadingSlot :
                    _$ce(2, 'div', (
                        _$ce(2, 'div', [
                            _$ce(2, 'div', null, 1, _$cn(`${k}-xmarkdown-loading-dot`)),
                            _$ce(2, 'div', null, 1, _$cn(`${k}-xmarkdown-loading-dot`)),
                            _$ce(2, 'div', null, 1, _$cn(`${k}-xmarkdown-loading-dot`))
                        ], 4, _$cn(`${k}-xmarkdown-loading-dots`))
                    ), 2, _$cn(`${k}-xmarkdown-loading`))
            ) :
            showEmpty ?
                (
                    (hasEmptySlot) ?
                        _$ce(2, 'div', emptySlot, 0, _$cn(`${k}-xmarkdown-empty`)) :
                        undefined
                ) :
                _$ce(2, 'div', [
                    _$ce(2, 'div', renderedNodes, 0, _$cn(`${k}-xmarkdown-body`)),
                    (shouldShowTypingSuffix()) ?
                        _$ce(2, 'div', [
                            _$ce(2, 'span'),
                            _$ce(2, 'span'),
                            _$ce(2, 'span')
                        ], 4, _$cn(`${k}-xmarkdown-typing-suffix`), _$tmp0) :
                        undefined
                ], 0, _$cn(`${k}-xmarkdown-content`), null, null, contentRef)
    ));
};